module.exports = __webpack_public_path__ + "img/NIC.c8cdb46a.svg";